<div class="auth-form">
  <div class="mt-150">
    <span class="title title--big">Изменение пароля</span>
  </div>
  <div class="mt-32">
    <form [formGroup]="changePasswordForm" (submit)="onSubmitChangePasswordForm()">
      <div class="mt-4">
        <app-field-password>
          <label>Текущий пароль</label>
          <input
            class="input-text"
            type="password"
            name="password"
            id="password"
            formControlName="password"
            [ngClass]="{
              'input-text-validation input-text--invalid': incorrectPasswordError
            }"
          />
        </app-field-password>
        <a routerLink="{{ '/' + AUTH_PATHS.recovery_access }}" class="link link--gray">Напомнить пароль</a>
      </div>
      <div class="mt-16">
        <app-field-password>
          <label>Новый пароль</label>
          <input
            class="input-text"
            type="password"
            name="new_password"
            placement="right"
            popoverClass="popover--w-350"
            [ngbPopover]="popContent"
            #p="ngbPopover"
            triggers="manual"
            autoClose="false"
            (focus)="openValidationPopover()"
            formControlName="new_password"
            id="newPassword"
            [ngClass]="{
              'input-text-validation input-text--invalid':
                (!newPasswordValidation.range && changePasswordForm.value.new_password.length > 0) ||
                (changePasswordForm.value.new_password_confirm &&
                  changePasswordForm.value.new_password !== changePasswordForm.value.new_password_confirm &&
                  changePasswordForm.value.new_password_confirm.length > 0) ||
                beforePasswordError ||
                recoveryChangeError
            }"
          />
        </app-field-password>
      </div>
      <div class="mt-8">
        <app-field-password>
          <label>Подтверждение пароля</label>
          <input
            class="input-text"
            type="password"
            name="new_password_confirm"
            id="newPasswordConfirm"
            formControlName="new_password_confirm"
            [ngClass]="{
              'input-text-validation input-text--invalid':
                (changePasswordForm.value.new_password_confirm &&
                  changePasswordForm.value.new_password !== changePasswordForm.value.new_password_confirm &&
                  changePasswordForm.value.new_password_confirm.length > 0) ||
                recoveryChangeError
            }"
          />
        </app-field-password>
        <input type="text" hidden id="newPasswordConfirmHidden" formControlName="new_password_confirm_hidden" />
      </div>
      <div class="mt-16">
        <button class="button" type="submit" id="appChangePasswordSubmit" [disabled]="!changePasswordForm.valid">Сменить пароль</button>
      </div>
    </form>
  </div>
  <div
    class="mt-16"
    *ngIf="
      changePasswordForm.value.new_password_confirm &&
      changePasswordForm.value.new_password !== changePasswordForm.value.new_password_confirm &&
      changePasswordForm.value.new_password_confirm.length > 0
    "
  >
    <app-message [type]="'error'">
      <div message-content>Пароли не совпадают</div>
    </app-message>
  </div>
  <div class="mt-16" *ngIf="changeAuthUserError">
    <app-message [type]="'error'">
      <div message-content>{{ changeAuthUserError }}</div>
    </app-message>
  </div>
</div>

<ng-template #popContent>
  <b class="title">{{ newPasswordValidation.passwordStatus }}</b>
  <div class="mt-16 mb-8">Надежный пароль может содержать и должен содержать:</div>
  <div>
    <div
      class="grid grid--gap-4"
      [ngClass]="{
        'color-green-dark': newPasswordValidation.minLength,
        'color-red-dark': !newPasswordValidation.minLength
      }"
    >
      <div class="grid__box grid__box--size-min pt-2">
        <app-icon [glyph]="'hd-check'" [size]="'16'" *ngIf="newPasswordValidation.minLength"></app-icon>
        <app-icon [glyph]="'hd-close-small'" [size]="'16'" *ngIf="!newPasswordValidation.minLength"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min">не менее 8 символов</div>
    </div>
    <div
      class="grid grid--gap-4"
      [ngClass]="{
        'color-green-dark': newPasswordValidation.lowercase,
        'color-red-dark': !newPasswordValidation.lowercase
      }"
    >
      <div class="grid__box grid__box--size-min pt-2">
        <app-icon [glyph]="'hd-check'" [size]="'16'" *ngIf="newPasswordValidation.lowercase"></app-icon>
        <app-icon [glyph]="'hd-close-small'" [size]="'16'" *ngIf="!newPasswordValidation.lowercase"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min">строчные латинские буквы</div>
    </div>
    <div
      class="grid grid--gap-4"
      [ngClass]="{
        'color-green-dark': newPasswordValidation.uppercase,
        'color-red-dark': !newPasswordValidation.uppercase
      }"
    >
      <div class="grid__box grid__box--size-min pt-2">
        <app-icon [glyph]="'hd-check'" [size]="'16'" *ngIf="newPasswordValidation.uppercase"></app-icon>
        <app-icon [glyph]="'hd-close-small'" [size]="'16'" *ngIf="!newPasswordValidation.uppercase"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min">прописные латинские буквы</div>
    </div>
    <div
      class="grid grid--gap-4"
      [ngClass]="{
        'color-green-dark': newPasswordValidation.numbers,
        'color-red-dark': !newPasswordValidation.numbers
      }"
    >
      <div class="grid__box grid__box--size-min pt-2">
        <app-icon [glyph]="'hd-check'" [size]="'16'" *ngIf="newPasswordValidation.numbers"></app-icon>
        <app-icon [glyph]="'hd-close-small'" [size]="'16'" *ngIf="!newPasswordValidation.numbers"></app-icon>
      </div>
      <div class="grid__box grid__box--size-min">цифры</div>
    </div>
  </div>
</ng-template>
